import { Organisation } from "./Organisation";
import { Solution } from "./Solution";
import { Task } from "./Task";

type Timestamp = number;

export enum AssessmentSolutionStatus {
  PENDING = "PENDING",
  REQUESTED = "REQUESTED",
  APPROVED = "APPROVED",
  MANAGER_REJECTED = "MANAGER_REJECTED",
  USER_REJECTED = "USER_REJECTED",
  EXISTING = "EXISTING", // Only goes to existing if assessment updated and approved
  RETRACTED = "RETRACTED",
}

export type AssessmentSolution = {
  id: string;
  organisation_id?: Organisation["id"];
  solutions: Record<Solution["id"], AssessmentSolutionStats>;
};

export type AssessmentSolutionStats = {
  id: string;
  final_score: number;
  status?: AssessmentSolutionStatus | null;
  hidden?: boolean;
  rejected_reason?: string | null;
  requested_at?: Timestamp | null;
  manager_responded_at?: Timestamp | null;
  tasks: Record<number, AssessmentSolutionTask>;
};

export const isAssessmentSolutionVisibleToUser = (
  solution: Pick<AssessmentSolutionStats, "hidden" | "status">,
) => {
  return (
    !solution.hidden || solution.status === AssessmentSolutionStatus.RETRACTED
  );
};

export type AssessmentSolutionTask = {
  completed_at?: Timestamp | null;
  task_order: number;
  task_id: string;
};

export type AssessmentSolutionTaskWithTask = AssessmentSolutionTask & {
  task: Task;
};

export type AssessmentSolutionWithSolutions = AssessmentSolutionStats & {
  solution: Solution;
};
